import type { News } from "../News.js";
import { blogPathMap } from "./blogPathMap.js";

export function getBlogDetailPath(blog: Pick<News, "locale" | "urlSlug">): string {
	return `${blogPathMap[blog.locale]}/${blog.urlSlug}`;
}
